import { Controller as BaseController } from 'stimulus'

import './index.scss'
import Rails from '@rails/ujs'
import { useDebounce } from 'stimulus-use'

export class Controller extends BaseController {
  static targets = ['searchInput', 'self', 'list', 'loading', 'additionalSubsectionItem', 'toggleButton']
  static debounces = ['triggerSearch']

  currentRequest = null

  connect() {
    useDebounce(this, { wait: 500 })
  }

  triggerSearch() {
    if (this.currentRequest) {
      this.currentRequest.abort()
    }

    Rails.ajax({
      type: 'GET',
      dataType: 'script',
      url: this.data.get('url'),
      beforeSend: (xhr) => {
        this.currentRequest = xhr
        this.listTarget.classList.add('hidden')
        this.loadingTarget.classList.remove('hidden')
        return true
      },
      data: $.param({
        search_text: this.searchInputTarget.value,
        element_id: this.selfTarget.id
      })
    })
  }

  toggleAllSubsections() {
    this.additionalSubsectionItemTargets.forEach(item => item.toggleAttribute('hidden'))
  }
}
